import { Injectable } from '@angular/core'
import { FormGroup, AbstractControl } from '@angular/forms'

@Injectable({
    providedIn: 'root',
})
export class UtilsService {
    public stringToKebabCase(str: string): string {
        return (
            str
                ?.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
                ?.map(x => x.toLowerCase())
                ?.join('-') || ''
        )
    }

    public getControlName(control: AbstractControl): string | null {
        let group = <FormGroup>control.parent

        if (!group) {
            return null
        }

        let name = ''

        Object.keys(group.controls).forEach(key => {
            let childControl = group.get(key)

            if (childControl !== control) {
                return
            }

            name = key
        })

        return name
    }
}
